<template>
  <v-container class="fill-height maintenance-view">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="10" md="7" lg="6">
        <v-card class="pa-6 text-center" elevation="2">
          <h1 class="text-h4 mb-4">{{ $t('auth.maintenance.title') }}</h1>
          <p class="text-body-1 mb-4">
            {{ $t('auth.maintenance.window') }}
          </p>
          <p class="text-body-2 mb-6">
            {{ $t('auth.maintenance.notAllowed') }}
          </p>
          <v-btn color="#A5D867" class="text-white font-weight-bold" @click="logout">
            {{ $t('navbar.menu.logout') }}
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Maintenance',
  methods: {
    async logout() {
      await firebase.auth().signOut()
      this.$router.replace({ name: 'Login' })
    },
  },
}
</script>

<style scoped>
.maintenance-view {
  min-height: calc(100vh - 120px);
}
</style>
